import React from "react"

//
// COMPANY
//
export const COMPANY_ADDRESS = process.env.NEXT_PUBLIC_COMPANY_ADDRESS
export const COMPANY_BRAND = (
    <>
        <span className="text-foreground/85">ohyai</span>
    </>
)
export const COMPANY_CONTACT_EMAIL = process.env.NEXT_PUBLIC_COMPANY_CONTACT_EMAIL
export const COMPANY_DESCRIPTION = process.env.NEXT_PUBLIC_COMPANY_DESCRIPTION
export const COMPANY_LOGO = process.env.NEXT_PUBLIC_COMPANY_LOGO || "logo.svg"
export const COMPANY_NAME = process.env.NEXT_PUBLIC_COMPANY_NAME || ""
export const COMPANY_NUMBER = process.env.NEXT_PUBLIC_COMPANY_NUMBER
export const COMPANY_OWNER = process.env.NEXT_PUBLIC_COMPANY_OWNER
export const COMPANY_PORTAL_ACTIVATED = process.env.NEXT_PUBLIC_COMPANY_PORTAL_ACTIVATED === "true"
export const COMPANY_PORTAL_IDENTIFIER = process.env.NEXT_PUBLIC_COMPANY_PORTAL_IDENTIFIER
export const COMPANY_PRODUCTS_EMAIL = process.env.NEXT_PUBLIC_COMPANY_PRODUCTS_EMAIL
export const COMPANY_TITLE = COMPANY_NAME.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
export const COMPANY_URL = process.env.NEXT_PUBLIC_COMPANY_URL

export const DOMAIN = process.env.NEXT_PUBLIC_DOMAIN ?? _inferDomainFromHostname()
export const ENVIRONMENT =
  process.env.NEXT_PUBLIC_ENVIRONMENT ?? _inferEnvironmentFromHostname() ?? "development"
export const IS_DEVELOPMENT = ENVIRONMENT === "development"
export const NAME = process.env.NEXT_PUBLIC_NAME || "default"
export const MEDIA_STORAGE_BUCKET = `${NAME}-media-${ENVIRONMENT}`
export const PLATFORM = process.env.NEXT_PUBLIC_PLATFORM ?? _inferPlatformFromHostname() ?? "local"

export const SIGN_REDIRECT = "/dashboard/think"

//
// PRIVATE FUNCTIONS
//
function _inferDomainFromHostname(): string | undefined {
  if (typeof window === "undefined") return undefined
  const { hostname } = window.location
  if (hostname === "localhost" || hostname === "127.0.0.1") return undefined
  const parts = hostname.split(".")
  if (parts.length >= 2) return parts.slice(-2).join(".")
  return undefined
}

function _inferEnvironmentFromHostname(): string | undefined {
  if (typeof window === "undefined") return undefined
  const { hostname } = window.location
  if (hostname === "localhost" || hostname === "127.0.0.1") return "development"
  if (hostname.includes("-development")) return "development"
  return "production"
}

function _inferPlatformFromHostname(): string | undefined {
  if (typeof window === "undefined") return undefined
  const { hostname } = window.location
  if (hostname === "localhost" || hostname === "127.0.0.1") return "local"
  return "vercel"
}